/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: inline-block;
  width: calc(250rem /14);
}
:host > .container {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
}
:host > .container > input {
  padding-left: calc(8rem /14);
}
:host > .container > davinci-icon-ref {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host > .container > davinci-icon-ref.clear {
  fill: #8E989D;
  fill: var(--davinci-color-outline, #8E989D);
  width: calc(18rem /14);
  height: calc(18rem /14);
}
:host > .container > davinci-icon-ref.clear.hidden {
  display: none;
}
:host > .spinner {
  display: none !important;
}
:host .list ::slotted(davinci-option) {
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
}
:host .list ::slotted(davinci-option:hover) {
  background-color: var(--davinci-color-background-3,#EEEFF0) !important;
}

:host([loading]) .search {
  display: none !important;
}
:host([loading]) .spinner {
  display: block !important;
}

:host([hidden]) {
  display: none;
}`;
export { style };
